import {Component, OnDestroy, OnInit} from '@angular/core';
import {ModelesPlatsService} from "../../../core/services/conditionnements/modeles-plats.service";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../core/utils/utils.service";
import {ButtonThemeEnum} from "../../../shared/ui/button/button-theme-enum";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {ParametreCalculConditionnementMl} from "../../../core/models/gestion-conditionnements/parametre-calcul-conditionnement-ml";
import {ParametreCalculConditionnementDTO} from "../../../core/dtos/conditionnement/parametre-calcul-conditionnemen-dto";

@Component({
  selector: 'yo-parametre_calcul_conditionnement_global_dialog',
  templateUrl: './parametre-calcul-conditionnement-global-dialog.component.html',
  styleUrls: ['./parametre-calcul-conditionnement-global-dialog.component.scss'],
  standalone: false
})
export class ParametreCalculConditionnementGlobalDialogComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  public isVisible: Boolean = false;

  public isCopy: Boolean = false;

  public parametrageList: ParametreCalculConditionnementMl[] = [];

  public selectedParametrage: ParametreCalculConditionnementMl;

  private subOpenParametreCalculConditionnementGlobalDialog: Subscription;

  private subGetParametreCalculConditionnementGlobal: Subscription;

  private subSaveConditionnement: Subscription;

  public siteListAvailableForCopy: SiteDTO[];

  public selectedSiteDestinationList: SiteDTO[];

  constructor(private utilsSvc: UtilsService,
              private modelePlatSvc: ModelesPlatsService,
              private authSvc: Auth2Service) {
  }

  ngOnInit(): void {
    this.initOpenParametreCalculConditionnementGlobalDialog();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenParametreCalculConditionnementGlobalDialog);
    this.utilsSvc.unsubscribe(this.subGetParametreCalculConditionnementGlobal);
    this.utilsSvc.unsubscribe(this.subSaveConditionnement);
  }

  initDefaultValues() {
    this.parametrageList = [];
    let siteLocauxIdList = this.authSvc.utilisateur.siteListLocaux.map(site => site.id);
    this.authSvc.utilisateur.sites.forEach((site: SiteDTO) => {
      let parametre = new ParametreCalculConditionnementMl(site)
      if (siteLocauxIdList.includes(site.id))
        parametre.siteLocal = true;
      this.parametrageList.push(parametre);
    });
    this.selectedParametrage = this.parametrageList[0];
  }

  initOpenParametreCalculConditionnementGlobalDialog(): void {
    this.subOpenParametreCalculConditionnementGlobalDialog = this.modelePlatSvc.openParametreCalculConditionnementGlobalDialog$.subscribe((isVisible) => {
      this.initDefaultValues();
      this.isVisible = isVisible;
      this.subGetParametreCalculConditionnementGlobal = this.modelePlatSvc.getParametreCalculConditionnementGlobal().subscribe(response => {
        response.forEach(trancheResponse => {
          let tranche = this.parametrageList.find((t) => t.siteId === trancheResponse.siteId);
          if (tranche) {
            tranche.minimumBarquetteRequired = trancheResponse.minimumBarquetteNumberRequired;
            if (trancheResponse.trancheReductionList?.length)
              tranche.trancheReductionList = trancheResponse.trancheReductionList;
          }
        })
      });
    });
  }

  closePopup() {
    this.isVisible = false;
  }

  save(): void {
    let toSave = this.parametrageList.filter((parametreCalculConditionnement) => parametreCalculConditionnement.isEdited)
      .map(parametre => new ParametreCalculConditionnementDTO(parametre));
    this.subSaveConditionnement = this.modelePlatSvc.saveParametreCalculConditionnementGlobal(toSave).subscribe((response) => {
      if (!response.error)
        this.closePopup();
    });
  }

  onSelectSite(siteId: Number) {
    this.selectedParametrage = this.parametrageList.find(param => param.siteId === siteId);
  }

  toggleCopyOptions(isCopy) {
    if (isCopy) {
      this.siteListAvailableForCopy = this.authSvc.utilisateur.siteListLocaux.filter(site => site.id != this.selectedParametrage.siteId);
    }
    this.isCopy = isCopy;
  }

  onSelectSiteDestination(siteList: SiteDTO[]) {
    this.selectedSiteDestinationList = siteList;
  }

  applyCopy() {
    this.parametrageList.filter(parametre =>
      this.selectedSiteDestinationList.map(site => site.id).includes(parametre.siteId)
    ).forEach(parametre => {
      parametre.setEdited();
      parametre.minimumBarquetteRequired = this.selectedParametrage.minimumBarquetteRequired;
      parametre.trancheReductionList = this.selectedParametrage.trancheReductionList
        .map(tranche => ({
            start: tranche.start,
            quantityAllowed: tranche.quantityAllowed
          }
        ));
    })
    this.toggleCopyOptions(false);
  }

}
